/* Reading Room — the theme's boot shim. dark-conversion, 2026-09-23; extended 2026-10-02 for the
 * calculator rework (run calculator-rework-build-2026-10-02, items C1 · C2 · C5 · C6 · C7).
 *
 * The engine exposes window.DF.ReadingRoom.mount(rootEl, opts) and nothing else: the contract
 * (§2.1) makes finding and mounting the elements the theme's job, not the engine's. This file is
 * that job. It is loaded after the engine, deferred, so it runs after first paint (R-V1).
 *
 * WHAT 2026-10-02 ADDED, and why each piece is here rather than in the engine
 * (assets/df-reading-room.js is dark-dev's file; this department does not edit it — plan §7.5):
 *
 *   1. ONE SHARED DATA OBJECT. mount() accepts `opts.data`, which is part of its own public
 *      signature. So this file parses #df-rr-data once and hands the same object to every element
 *      on the page. That is what makes 2 and 3 possible at all.
 *   2. THE DEFERRED HALF OF `strings` (C6). The page used to ship 65,810 B of inline JSON, 32,395 B
 *      of it strings, including all 19 pair readings — of which a visitor reads exactly one. They
 *      now live in assets/rr-birth-defer-<lang>.json and are merged in here, BEFORE the birth
 *      element mounts, so the engine never sees a partial object. The plan suggested riding the
 *      existing cards_url bundle; that cannot work — the engine's mergeBundle() merges only into
 *      `data.cards`, keyed by card id, and never touches `data.strings`.
 *      If the fetch fails the element still mounts: the reading falls back to the engine's own empty
 *      shape, which is thin but not broken, and a console warning says so.
 *   3. THE DECK PICKER. The ENGINE's, since engine c11df1ec (2026-10-02). This file only moves it
 *      into the slot the section declared, [data-rr-deck-picker], and never rebuilds it.
 *   4. `deck_pick` WITH THE HONEST DECK ID. The engine builds its event params from its own frozen
 *      DECK_IDS slot, so while Vintage Borderless rides the `holographic-crystal` slot its events
 *      would name the wrong deck. This file fires `deck_pick` itself with the owner's real art id,
 *      so at least the pick is measured correctly until dark-dev widens that list.
 *   5. THE SHIPPING-AND-RETURNS LINE (C2). The offer block is built by the engine, so the line is
 *      appended to it here, from text Liquid built out of the market's own threshold metafield.
 *   6. THE REVEAL GATE (C7). The capture form, share row and cross-link are served `hidden` and are
 *      shown on the engine's own `reveal` event — or immediately on ?customer_posted=true, where
 *      Liquid has already dropped the attribute to carry the success state.
 *   8. THE RESULT SCREEN (2026-10-23, run calculator-journey-fix-2026-10-23): her cards shown at
 *      once in the best-seller deck when she has not picked one, the offer and the e-mail ask moved
 *      up under the reading, why the deck suits her plus the free-book learning path (EN), and her
 *      birth cards carried to the signup as customer tags. Section 8 below says why for each.
 *
 * It is written to work with either engine — dark-dev's assets/df-reading-room.js or this
 * department's retired stand-in — because both hold the same mount contract.
 */
(function () {
  'use strict';
  var SEL = 'df-table, df-yes-no, df-daily-card, df-birth-cards, df-deck-offer, df-ai-note';

  function ready(node) {
    /* the contract's signal is a df-ready CustomEvent on the element; the attribute is this
       theme's own convenience so a walk, a screenshot or a CSS rule can wait for it too. */
    node.setAttribute('data-df-ready', '1');
  }
  function warn() {
    if (window.console && console.warn) console.warn.apply(console, arguments);
  }
  function json(id) {
    var n = document.getElementById(id);
    if (!n) return null;
    try { return JSON.parse(n.textContent || ''); } catch (e) { warn('[rr] #' + id + ' is not valid JSON', e && e.message); return null; }
  }

  /* ---------------------------------------------------------------- 1 · the one data object */
  var DATA = json('df-rr-data');
  var EXTRA = json('rr-calc-extra') || {};

  /* ------------------------------------------- 2 · merge the deferred half of `strings` (C6) */
  function mergeDeferred(data, payload) {
    if (!data || !payload || typeof payload !== 'object') return 0;
    var src = payload.strings && typeof payload.strings === 'object' ? payload.strings : payload;
    if (!data.strings || typeof data.strings !== 'object') data.strings = {};
    var n = 0;
    for (var k in src) {
      if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
      if (k === '__proto__' || k === 'constructor' || k === 'prototype') continue;
      var incoming = src[k];
      var existing = data.strings[k];
      /* `birth` is the only nested object either side carries; merge it key-by-key so an inline
         label is never clobbered by a deferred file that happens to lack it. Everything else is a
         string or a flat array and is replaced outright. */
      if (k === 'birth' && existing && typeof existing === 'object' && !Array.isArray(existing) &&
          incoming && typeof incoming === 'object' && !Array.isArray(incoming)) {
        for (var b in incoming) {
          if (!Object.prototype.hasOwnProperty.call(incoming, b)) continue;
          if (b === '__proto__' || b === 'constructor' || b === 'prototype') continue;
          data.strings.birth[b] = incoming[b];
          n++;
        }
      } else {
        data.strings[k] = incoming;
        n++;
      }
    }
    return n;
  }

  var deferredReady = (function () {
    var url = DATA && typeof DATA.strings_defer_url === 'string' ? DATA.strings_defer_url : null;
    if (!url || url.charAt(0) !== '/' || url.charAt(1) === '/') return Promise.resolve(false);
    if (typeof fetch !== 'function') { warn('[rr] no fetch; the deferred readings stay unloaded'); return Promise.resolve(false); }
    function once(attempt) {
      return fetch(url, { credentials: 'omit' })
        .then(function (r) { if (!r || !r.ok) throw new Error('status ' + (r && r.status)); return r.json(); })
        .then(function (j) { return mergeDeferred(DATA, j) > 0; })
        .catch(function (e) {
          if (attempt < 1) return once(attempt + 1);
          warn('[rr] deferred strings not loaded (' + (e && e.message) + ') — the reading will be thin');
          return false;
        });
    }
    return once(0);
  })();

  /* ---------------------------------------------------------------------- the question box */
  /* The question box lives in a CLOSED shadow root (contract §2.2: rendered by the THEME, not the
     engine). Measured on the preview 2026-09-23: with the question typed into an ordinary <input>,
     Meta's app pixel POSTed the typed text to facebook.com. The pixel is a Shopify app pixel, not
     theme code, so it cannot be gated from the theme — but its scraper walks the light DOM, and a
     closed shadow root is not in it. R-X2 says the question never leaves her phone.

     2026-09-24 BUG FOUND (hub, third phone walk): `<df-question>` was never a registered custom
     element in dev's engine — the engine reads `opts.questionEl.value`, and an unmounted
     `<df-question>` has no `.value` at all, so every typed question was silently discarded with no
     console error. This mounts the real input the SAME way the retired stand-in did. */
  function mountQuestion(host) {
    if (!host || host.__rrQ) return host && host.__rrQ;
    var root;
    try { root = host.attachShadow({ mode: 'closed', delegatesFocus: true }); } catch (e) { return null; }
    var st = document.createElement('style');
    st.textContent = ':host{display:block;margin:0 0 1rem}' +
      'label{display:block;font:600 .88rem/1.4 var(--rr-sans,system-ui);color:#2C1A0E;margin:0 0 .35rem}' +
      'input{width:100%;min-height:48px;padding:.6rem .75rem;font:400 1rem/1.4 var(--rr-sans,system-ui);' +
      'color:#2C1A0E;background:#fff;border:1px solid #8B6F5A;border-radius:8px;box-sizing:border-box}' +
      'input:focus-visible{outline:3px solid #2C1A0E;outline-offset:2px}' +
      'p{font:400 .82rem/1.4 var(--rr-sans,system-ui);color:#8B6F5A;margin:.35rem 0 0}';
    root.appendChild(st);
    var id = 'q-' + Math.random().toString(36).slice(2, 8);
    var lab = document.createElement('label');
    lab.setAttribute('for', id);
    lab.textContent = host.getAttribute('label') || '';
    var inp = document.createElement('input');
    inp.type = 'text';
    inp.id = id;
    inp.maxLength = 200;
    inp.autocomplete = 'off';
    inp.spellcheck = false;
    inp.setAttribute('autocapitalize', 'sentences');
    inp.placeholder = host.getAttribute('placeholder') || '';
    inp.setAttribute('data-hj-suppress', '');
    inp.setAttribute('data-clarity-mask', 'true');
    inp.setAttribute('data-recording-sensitive', '');
    var hint = document.createElement('p');
    hint.textContent = host.getAttribute('hint') || '';
    root.appendChild(lab); root.appendChild(inp); root.appendChild(hint);
    host.setAttribute('tabindex', '-1');
    host.setAttribute('data-rr-q', '1');
    host.__rrQ = inp;
    return inp;
  }
  function resolveQuestionEl(sel) {
    var node = sel ? document.querySelector(sel) : null;
    if (!node) return null;
    if (node.tagName && node.tagName.toLowerCase() === 'df-question') return mountQuestion(node);
    return node;
  }

  /* ---------------------------------------------------------- 5 · the shipping/returns line */
  function shipLine(offerBox) {
    if (!offerBox || offerBox.querySelector('.rr-offer-ship')) return;
    var html = EXTRA && typeof EXTRA.ship_html === 'string' ? EXTRA.ship_html : '';
    if (!html) return;
    var p = document.createElement('p');
    p.className = 'rr-offer-ship';
    /* The string is built by Liquid, escaped there, and carries exactly one anchor to a policy URL
       Liquid also produced. No visitor input reaches it. */
    p.innerHTML = html;
    var btn = offerBox.querySelector('.df-rr-offer__add, .df-rr-offer__alt');
    if (btn && btn.parentNode === offerBox) offerBox.insertBefore(p, btn.nextSibling);
    else offerBox.appendChild(p);
    /* run calculator-monetize-2026-11-03: the Christmas cut-off, en-US only, Liquid-gated by date */
    var xmas = EXTRA && typeof EXTRA.xmas_line === 'string' ? EXTRA.xmas_line : '';
    if (xmas && !offerBox.querySelector('.rr-offer-xmas')) offerBox.insertBefore(el('p', 'rr-offer-xmas', xmas), p.nextSibling);
  }
  /* 2026-10-09, run calculator-buy-point-2026-10-09: PRICE AFTER HER CODE, at the buy point,
     before she taps. Persona SUMMARY.md, all four visitors named the missing price-after-code as
     part of the top blocker. DATA.decks[].product.price_after_code is the full price times 0.80,
     computed and money-formatted in Liquid (snippets/rr-data.liquid) -- the same 20% every
     code_applied/code_manual sentence already promises, read from the live product price, never
     typed twice. Shown only when a code is enabled for this deck (EXTRA.code_enabled); worded with
     EXTRA.code_manual, which is already localized in all six languages, so no new hardcoded string
     is added here. */
  function priceAfterCodeLine(offerBox) {
    if (!offerBox || offerBox.querySelector('.rr-offer-price-code')) return;
    if (!EXTRA || !EXTRA.code_enabled || typeof EXTRA.code_manual !== 'string' || !EXTRA.code_manual) return;
    var deckId = offerBox.getAttribute('data-deck');
    var decks = (DATA && DATA.decks) || [];
    var deck = null;
    for (var i = 0; i < decks.length; i++) { if (decks[i] && decks[i].deck_id === deckId) { deck = decks[i]; break; } }
    var priceAfter = deck && deck.product && deck.product.price_after_code;
    if (!priceAfter) return;
    var p = document.createElement('p');
    p.className = 'rr-offer-price-code';
    /* run calculator-monetize-2026-11-03: code_manual says "use your code at checkout" while the button
       applies it in place and then says "your 20% is already on it" - one buy box, two instructions.
       This line now says what the button does, sits ABOVE it, and keeps code_manual as the fallback. */
    p.textContent = t('price_with_code', { price: priceAfter }) || (EXTRA.code_manual + ' (' + priceAfter + ')');
    var btn = offerBox.querySelector('.df-rr-offer__add, .df-rr-offer__alt');
    if (btn && btn.parentNode === offerBox) offerBox.insertBefore(p, btn);
    else offerBox.appendChild(p);
  }
  /* ----------------------------------------------- 5b · her code line is the ENGINE's line now
     This shim used to build it: BIRTH + DDMM from the two numbers on her screen, printed under the
     buy button. Both halves of that are gone, and the second one matters.

     The FORM changed by the hub's 02.10 ruling. A redeemed BIRTH1403 would have carried her birth
     day and month into a Shopify order, which breaks this page's own promise that the date never
     leaves her phone. The code is now derived from the two CARDS she drew — BIRTH-MOON-HERMIT — and
     says which pair she got and nothing about when she was born.

     The PLACE changed too: engine c11df1ec renders `strings.deck_handoff` as `.df-rr-handoff`
     directly above the buy block and fills {deck} and {code} itself. So this file no longer writes a
     line; it only decides WHICH sentence the engine is given, and what the buy button says. Both are
     set on the data object before mount, which is the engine's own public contract — see §6b. */

  /* ------------------------------------------- 5c · "Shop This Deck" applies her code in place
     The hub told the owner that the button adds the deck with the 20% already on it and that she
     stays on the page. These twenty lines are what makes that true.

     HOW. `GET /discount/<CODE>` is Shopify's own storefront route: it validates the code and stores
     it on her session. Fetched same-origin it needs no navigation, no form and no checkout. `/cart.js`
     then reports `discount_codes:[{code, applicable}]` and the per-line allocation, which is the
     storefront confirming the money — so the line she reads is a read-back, never an assumption.

     WHERE THE CODE COMES FROM. `.df-rr-handoff[data-code]`, which the engine filled from the two
     cards she drew. It is never built here and never contains anything she typed.

     WHAT IT NEVER DOES. It never touches the engine's add — that runs first and is left alone — and
     it never blocks it. Every failure path ends with the deck in her cart and a line telling her to
     use the code at checkout, which is exactly where she stood before this existed. */
  /* dark-dev's own hand-off, engine def7c75a: `df-cart` fires once per press with
     `{ ok, error, deck, code }` and is identical from the full block's button and the strip's. Kept
     as the LAST resort for the code rather than the first, so a second press can never be served the
     previous press's detail while the control it came from is standing right there with the value on
     it. Read, never acted on: the apply sequence below is still started by the click, because that
     timing is the one this department measured (5 carts of 5 discounted, 1.2-2.0 s). */
  var lastCart = null;
  document.addEventListener('df-cart', function (e) {
    var d = (e && e.detail) || {};
    lastCart = { ok: !!d.ok, error: d.error || null, deck: d.deck || null, code: d.code || null };
  });

  /* WHERE HER CODE COMES FROM, in order of how close it is to the thing she pressed. The full deck
     block renders `.df-rr-handoff[data-code]`; the strip carries `data-code` on itself and on its
     own button and renders no handoff line at all. Resolving from the control outwards is what lets
     ONE mechanism serve both buttons — and it is never built here and never contains anything she
     typed, whichever branch answers. */
  function herCode(btn) {
    var own = btn && btn.getAttribute ? btn.getAttribute('data-code') : null;
    if (own) return own;
    var near = btn && btn.closest ? btn.closest('[data-code]') : null;
    if (near) return near.getAttribute('data-code');
    var h = document.querySelector('.df-rr-handoff[data-code], .df-rr-strip[data-code]');
    if (h) return h.getAttribute('data-code');
    return lastCart && lastCart.code ? lastCart.code : null;
  }

  function applyHerCode(box, btn) {
    var code = herCode(btn);
    var ok = EXTRA && EXTRA.code_applied, manual = EXTRA && EXTRA.code_manual;
    if (!code || !/^BIRTH(-[A-Z]+){1,3}$/.test(code) || typeof fetch !== 'function' || !ok || !manual) return;
    var note = box.querySelector('.rr-offer-applied');
    if (!note) {
      note = document.createElement('p');
      note.className = 'rr-offer-applied';
      note.setAttribute('aria-live', 'polite');
      var anchor = box.querySelector('.df-rr-offer__status') || box.querySelector('.df-rr-strip__status') || btn;
      if (anchor && anchor.parentNode === box) box.insertBefore(note, anchor.nextSibling); else box.appendChild(note);
    }
    note.textContent = '';
    function cart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    /* `?redirect=/cart.js` is not cosmetic. The route answers 302 and the browser follows it, so the
       redirect TARGET is most of the cost: measured on this store, the bare route takes 1,274 ms and
       pulls 422 kB of homepage, `?redirect=/cart` 1,666 ms and 361 kB, and `?redirect=/cart.js`
       874 ms and 17 kB. It also lands on the cart as JSON — which is the cart AFTER the code was
       stored — so the confirmation comes back inside the same round trip instead of costing another. */
    function storeCode() {
      return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }

    /* THE CODE GOES ON HER SESSION IMMEDIATELY, NOT AFTER THE ADD.
       `/discount/<CODE>` stores the code on the session and does not care whether the cart holds
       anything yet — the discount is evaluated against whatever is in the cart when it is read. An
       earlier version waited for the add to appear in /cart.js first, and this department's own
       verifier measured what that cost: no discount at +1.2 s, applied at +3 s and +6 s. A shopper who
       taps and goes straight to the cart could see full price, and on a slow connection reach checkout
       before her code was on the session. Firing it here, in parallel with the engine's add, shrinks
       that window to about one round trip. */
    /* NOT in parallel with the add, and that is a measured decision rather than a cautious one. A code
       stored against an empty cart is not priced onto a line created afterwards until something
       re-evaluates the cart: firing it early put the deck in her cart with no discount at +1.2 s and
       only discounted by +3 s. Applied AFTER the add, the discount route returns the priced cart
       itself. So: notice the add quickly, then one call that both applies and confirms. */

    /* The CONFIRMING read still waits for the add, because the money is the only thing worth saying
       and it cannot be read before there is a line to read it against. */
    /* 150 ms, not 400: every step of this poll is time she can spend in a cart at full price, and the
       engine's add is the only part of the wait a theme cannot shorten. */
    function settled(tries) {
      return cart().then(function (c) {
        if (c && c.item_count > 0) return c;
        if (tries <= 0) return null;
        return new Promise(function (s) { setTimeout(s, 150); }).then(function () { return settled(tries - 1); });
      });
    }
    function money(c) {
      return (c.items || []).reduce(function (a, i) {
        return a + (i.line_level_discount_allocations || []).reduce(function (t, x) { return t + (x.amount || 0); }, 0);
      }, 0);
    }
    function applied(c) {
      return (c.discount_codes || []).some(function (d) { return d.code === code && d.applicable === true; })
        && money(c) > 0;
    }
    settled(40)
      .then(function (full) {
        if (!full) throw new Error('cart still empty');
        /* one call: it stores the code AND returns the cart priced with it */
        return storeCode().then(function (priced) {
          if (priced && priced.item_count > 0) return priced;
          return cart();
        });
      })
      .then(function (c) {
        if (applied(c)) return c;
        /* one retry, for a race nobody has seen but which costs one round trip to rule out */
        return storeCode().then(function (again) { return (again && again.item_count > 0) ? again : cart(); });
      })
      .then(function (c) {
        var on = applied(c);
        note.textContent = on ? ok : manual;
        note.className = 'rr-offer-applied' + (on ? ' is--on' : '');
      })
      .catch(function (e) {
        note.textContent = manual;
        note.className = 'rr-offer-applied';
        warn('[rr] code not applied in place (' + (e && e.message) + '); her cart is untouched and the code still works at checkout');
      });
  }

  function wireApply(box, sel) {
    var btn = box.querySelector(sel);
    if (!btn || btn.getAttribute('data-rr-apply')) return;
    btn.setAttribute('data-rr-apply', '1');
    btn.addEventListener('click', function () { applyHerCode(box, btn); });
  }

  function decorateOffer(box) { offerName(box); shipLine(box); priceAfterCodeLine(box); wireApply(box, '.df-rr-offer__add'); fitOffer(box); }

  /* THE STRIP, directly under her cards (owner, 02.10 ~22:30: «колода… слишком далеко»). It gets the
     click wiring and nothing else:
       · no `shipLine()` — the shipping-and-returns clause belongs under the real buy block 2,762 px
         further down, and a compact reminder that sprouts a second small-print paragraph has stopped
         being compact;
       · the note lands inside `.df-rr-strip__body`, after the engine's own aria-live status, because
         `applyHerCode` only inserts next to an anchor that is its own child.
     A strip with no button is the out-of-stock path — dev renders "Back soon" plus a link to a deck
     she can actually buy — so there is nothing to wire and nothing to fix. */
  function decorateStrip(strip) {
    var body = strip.querySelector('.df-rr-strip__body') || strip;
    wireApply(body, '.df-rr-strip__add');
  }

  function watchOffers(scope) {
    var MO = window.MutationObserver;
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('.df-rr-offer'), decorateOffer);
    Array.prototype.forEach.call(root.querySelectorAll('.df-rr-strip'), decorateStrip);
    if (typeof MO !== 'function') return;
    var obs = new MO(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var added = recs[i].addedNodes || [];
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('df-rr-offer')) decorateOffer(n);
          if (n.classList && n.classList.contains('df-rr-strip')) decorateStrip(n);
          if (!n.querySelectorAll) continue;
          Array.prototype.forEach.call(n.querySelectorAll('.df-rr-offer'), decorateOffer);
          Array.prototype.forEach.call(n.querySelectorAll('.df-rr-strip'), decorateStrip);
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------- 6 · the reveal gate */
  /* 2026-10-23 hub: querySelectorAll, not querySelector. Since 09.10 BOTH the outer section and the
     inner #bcc-email-section carry [data-rr-asks][hidden]; querySelector opened only the outer one, so
     the e-mail form stayed hidden after every reveal (last calculator signup 08.10). */
  function openAsks() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rr-asks]'), function (block) { block.hidden = false; });
  }

  /* ------------------------------------------- 3 + 4 · the deck picker, which is now the ENGINE's
     Everything that used to live here — five chips wired as a radiogroup, arrow keys, a <dialog>
     that enlarged a cover, a destroy()/mount() round trip on every pick — is deleted, and that is
     the point of this run. Engine c11df1ec builds the picker itself, switches the deck in place
     without a re-mount, fires its own `deck_pick` with the deck she actually chose, and opens the
     enlarged cover as an inline panel with a same-tab product link. Two implementations of one
     control is how a page ends up with two pickers, or with a tap that does nothing because the
     other one swallowed it.

     What is left is the one thing a theme still owns: putting the engine's picker inside the slot
     the section declared for it, so the position is ours and stated rather than inherited from the
     engine's DOM walk. mountWith() inserts `.df-rr-birth__pickerwrap` immediately before
     [data-rr-birth-go]; this moves it into [data-rr-deck-picker], which sits in exactly that gap.
     If the move ever fails the picker stays where the engine put it — the same place, one level up —
     so this can only ever be cosmetic, never load-bearing. */
  function birthEl() { return document.querySelector('df-birth-cards'); }

  /* 2026-10-08, hub return: a compact capture must sit directly under the two revealed cards,
     above the reading. It lives OUTSIDE <df-birth-cards> on purpose (the engine's own adoption pass
     strips `name` off anything it adopts, which would break a real submitting form), so this is a
     plain DOM move, not an adoption -- same resilience contract as adoptPicker: if the slot or the
     wrap is missing, nothing happens and the page is exactly as it was before this patch. */
  function adoptEmailCompact(node) {
    try {
      var cardsRow = node.querySelector('.df-rr-birth__cards');
      var wrap = document.querySelector('[data-rr-email-compact]');
      if (!cardsRow || !wrap || wrap.previousElementSibling === cardsRow) return;
      wrap.hidden = false;
      cardsRow.parentNode.insertBefore(wrap, cardsRow.nextSibling);
    } catch (e) { warn('[rr] email-compact slot not adopted', e && e.message); }
  }

  /* 2026-10-09, run calculator-free-book-2026-10-09: the free-book offer lives OUTSIDE
     <df-birth-cards> too, same reason and same contract as adoptEmailCompact above -- it is
     static content with a real cross-origin download <a>, not a control the engine should adopt.
     Moved to right after .df-rr-birth__body (the "Who You Are" paragraph(s)), before
     .df-rr-birth__glance-intro -- about the first 20% of the reading, owner's own anchor. */
  /* 2026-10-23: held by reference. Once moved into the reading, the book offer lives inside the
     engine's output box, and "Try another date" empties that box (clear(_out)), so a fresh
     document lookup on the second reading found nothing and the book was gone for good. */
  var BOOK = null;
  function adoptBookOffer(node) {
    try {
      var body = node.querySelector('.df-rr-birth__body');
      var wrap = BOOK || (BOOK = document.querySelector('[data-rr-book-offer]'));
      if (!body || !wrap || wrap.previousElementSibling === body) return;
      wrap.hidden = false;
      body.parentNode.insertBefore(wrap, body.nextSibling);
    } catch (e) { warn('[rr] book-offer slot not adopted', e && e.message); }
  }
  /* --------------------------------------------------- 8 · the result screen (2026-10-23)
     Run calculator-journey-fix-2026-10-23 (hub brief, items 3 · 4 · 7 · 8). Everything here works on
     the engine's finished DOM and is wrapped, so a missing node leaves the page as the engine built it.
       a. THE DEFAULT DECK. With no deck chosen and none remembered, her cards are shown in the Borderless
          Vintage, the deck we recommend to beginners (owner 20.10: «всем новичкам мы советуем нашу
          винтажную… Поэтому ее ставь»; it replaces the brief's best-seller default), else in
          DATA.offer.best_seller, instead of a disabled "Show my cards". The engine's picker
          stays, so one tap switches. Set as the `deck` attribute before mount: render() reads it first.
          The engine writes `df.rr.v1.birth` only on a real pick, so a remembered deck is always hers.
       b. THE ORDER UNDER THE CARDS. The deck offer and the e-mail ask come straight after the reading;
          the card links, "Your Birth Date, Added Up" and "Try another date" go last. Every reading
          re-runs this, because the engine's clear(_out) drops anything we moved into it (that is also
          why the book and the e-mail section are held by reference, not looked up again).
       c. THE OFFER, EN only: why the deck suits her (her own cards + one true deck fact) and the
          learning path — the free 91-page book, then the Borderless Vintage for a beginner.
       d. HER READING AS CUSTOMER TAGS (dark-marketing delivery-spec §2): `bcc-reading`,
          `bcc-key-<key>`, `birth-card-<slug>` per card and `bcc-y2027-<n>` (her 2027 year card number,
          5-17, from the engine's own DF.ReadingRoom.engine.yearCard — hub decision 23.10), added only to
          a form that shows the data line [data-rr-data-line] telling her so. No birth date in any tag.
       e. The engine's own `email_submit` event, wired by marking the form [data-rr-birth-email]. */
  var IS_EN = !!(DATA && DATA.lang === 'en');
  var deckState = { current: null, preset: false, picked: false };
  var EMAIL = null;
  var SLUGS = ['the-fool', 'the-magician', 'the-high-priestess', 'the-empress', 'the-emperor', 'the-hierophant',
    'the-lovers', 'the-chariot', 'strength', 'the-hermit', 'wheel-of-fortune', 'justice', 'the-hanged-man',
    'death', 'temperance', 'the-devil', 'the-tower', 'the-star', 'the-moon', 'the-sun', 'judgement', 'the-world'];
  /* 2026-10-23, run calculator-conversion-followup-2026-10-23 (hub brief item 3): every sentence this file adds
     to the result now comes from dark-sengo's mount-strings.json (dark-sengo/workspace/calculator-locales-2026-10-23),
     all six languages, so the fit lines, the learning path and the shown-in line run in every locale, not EN only.
     The EN values are byte-identical to the strings that were hard-coded here, except path_book (the 91-page PDF
     says "PARTS 1 TO 4", so "part one" was false). JA's path_book says the book is the English edition. */
  var LC = (DATA && typeof DATA.lang === 'string' ? DATA.lang : 'en').slice(0, 2);
  var STR = {"en":{"shown_in":"Shown in the {deck}.","change_deck":"Change deck","how_counted":"How we counted ↓","fit_heading_default":"Your cards in this deck","fit_heading_picked":"Why this deck suits you","fit_line_one":"Your card, {card}, is in this deck, ready to hold and lay out yourself.","fit_line_many":"Your cards, {a} and {b}, are in this deck, ready to hold and lay out yourself.","list_sep":", ","fact_sunlight":"Laminated and wipe-clean, so it stands up to everyday shuffling.","fact_moonlight_gold":"Gold rainbow foil on black card: a beautiful second deck once you know the cards.","fact_moon_magic":"Linen-finish cards: matte, with a soft texture in the hand.","fact_pink_moon":"Laminated and wipe-clean, with matching pink accessories.","fact_vintage_borderless":"The original 1909 art, printed edge to edge: the deck we recommend to beginners.","path_heading":"New to tarot? Start here:","path_book":"Read {book} free: parts 1 to 4 of our course, 91 pages.","book_title":"Your First Reading","path_guidebook":"Read with the PDF guidebook we email you with your deck.","price_with_code":"Your price with your 20% code: {price}. We add the code for you when you tap the button below.","path_begin_vintage":"Begin with the Borderless Vintage, the deck we recommend to beginners.","see_cards_in_it":"See your cards in it"},"de":{"shown_in":"Gezeigt im {deck}.","change_deck":"Deck wechseln","how_counted":"So haben wir gerechnet ↓","fit_heading_default":"Deine Karten in diesem Deck","fit_heading_picked":"Warum dieses Deck zu dir passt","fit_line_one":"Deine Karte, {card}, ist in diesem Deck enthalten – bereit, dass du sie in die Hand nimmst und selbst legst.","fit_line_many":"Deine Karten, {a} und {b}, sind in diesem Deck enthalten – bereit, dass du sie in die Hand nimmst und selbst legst.","list_sep":", ","fact_sunlight":"Laminiert und abwischbar, damit sie das tägliche Mischen gut aushalten.","fact_moonlight_gold":"Goldene Regenbogenfolie auf schwarzem Karton: ein wunderschönes Zweitdeck, sobald du die Karten kennst.","fact_moon_magic":"Karten mit Leinenstruktur: matt und mit weicher Haptik in der Hand.","fact_pink_moon":"Laminiert und abwischbar, mit passendem Zubehör in Rosa.","fact_vintage_borderless":"Die originalen Illustrationen von 1909, randlos bis an den Kartenrand gedruckt.","fact_learning_deck":"Die Bedeutungen stehen auf jeder Karte, dazu liegt ein gedrucktes Handbuch auf Deutsch in der Schachtel, und nach dem Kauf bekommst du den kompletten Tarot-Kurs in deiner Sprache per persönlichem Link.","path_heading":"Neu im Tarot? Fang hier an:","path_book":"Lies {book} kostenlos: Teil 1 bis 4 unseres Kurses, 91 Seiten.","book_title":"Deine erste Legung","path_guidebook":"Lies mit dem PDF-Begleitbuch, das wir dir zu deinem Deck mailen.","price_with_code":"Dein Preis mit deinem 20%-Code: {price}. Wir lösen ihn für dich ein, sobald du unten auf den Button tippst.","path_begin_vintage":"Lies mit dem gedruckten Begleitbuch aus der Schachtel.","see_cards_in_it":"Sieh dir deine Karten darin an"},"es":{"shown_in":"Se muestra en el {deck}.","change_deck":"Cambiar de mazo","how_counted":"Cómo lo hemos calculado ↓","fit_heading_default":"Tus cartas en este mazo","fit_heading_picked":"Por qué este mazo encaja contigo","fit_line_one":"Tu carta, {card}, está en este mazo, lista para tenerla en las manos y extenderla sobre la mesa.","fit_line_many":"Tus cartas, {a} y {b}, están en este mazo, listas para tenerlas en las manos y extenderlas sobre la mesa.","list_sep":", ","fact_sunlight":"Plastificadas y fáciles de limpiar con un paño, así que aguantan el barajeo de cada día.","fact_moonlight_gold":"Foil dorado con efecto arcoíris sobre cartulina negra: un segundo mazo precioso cuando ya conoces las cartas.","fact_moon_magic":"Cartas con acabado de lino: mate y con una textura suave en la mano.","fact_pink_moon":"Plastificadas y fáciles de limpiar, con accesorios rosas a juego.","fact_vintage_borderless":"El arte original de 1909, impreso hasta el borde: el mazo que recomendamos para empezar.","path_heading":"¿Primera vez con el tarot? Empieza aquí:","path_book":"Lee {book} gratis: las partes 1 a 4 de nuestro curso, 91 páginas.","book_title":"Tu primera lectura","path_guidebook":"Léelo con la guía en PDF que te enviamos por email con tu mazo.","price_with_code":"Tu precio con tu código del 20%: {price}. Lo aplicamos por ti al tocar el botón de abajo.","path_begin_vintage":"Estrena el tarot con el Borderless Vintage, el mazo que recomendamos para empezar.","see_cards_in_it":"Ver tus cartas en este mazo"},"fr":{"shown_in":"Présenté dans le {deck}.","change_deck":"Changer de jeu","how_counted":"Comment nous avons compté ↓","fit_heading_default":"Vos cartes dans ce jeu","fit_heading_picked":"Pourquoi ce jeu vous convient","fit_line_one":"Votre carte, {card}, se trouve dans ce jeu, prête à être prise en main et disposée par vous.","fit_line_many":"Vos cartes, {a} et {b}, se trouvent dans ce jeu, prêtes à être prises en main et disposées par vous.","list_sep":", ","fact_sunlight":"Plastifiées et lavables d'un coup de chiffon : elles supportent les mélanges de tous les jours.","fact_moonlight_gold":"Dorure or aux reflets arc-en-ciel sur carton noir : un très beau second jeu, une fois que vous connaissez les cartes.","fact_moon_magic":"Cartes à la finition lin : mates, avec une texture douce sous les doigts.","fact_pink_moon":"Plastifiées et lavables d'un coup de chiffon, avec des accessoires roses assortis.","fact_vintage_borderless":"L'illustration originale de 1909, imprimée jusqu'aux bords.","fact_learning_deck":"Les significations sont imprimées sur chaque carte, la boîte contient un livret imprimé en français et, après l'achat, vous recevez par e-mail un cours de tarot complet en français, avec un lien de téléchargement personnel.","path_heading":"Nouveau dans le tarot ? Commencez ici :","path_book":"Lisez {book} gratuitement : les parties 1 à 4 de notre cours, 91 pages.","book_title":"Votre première lecture","path_guidebook":"À lire avec le guide PDF que nous vous envoyons par e-mail avec votre jeu.","price_with_code":"Votre prix avec votre code de 20 % : {price}. Nous l'appliquons pour vous dès que vous touchez le bouton ci-dessous.","path_begin_vintage":"À lire avec le livret imprimé fourni dans la boîte.","see_cards_in_it":"Voir vos cartes dans ce jeu"},"it":{"shown_in":"Qui nel {deck}.","change_deck":"Cambia mazzo","how_counted":"Come abbiamo fatto il calcolo ↓","fit_heading_default":"Le tue carte in questo mazzo","fit_heading_picked":"Perché questo mazzo fa per te","fit_line_one":"La tua carta, {card}, è in questo mazzo, pronta da tenere in mano e da stendere a modo tuo.","fit_line_many":"Le tue carte, {a} e {b}, sono in questo mazzo, pronte da tenere in mano e da stendere a modo tuo.","list_sep":", ","fact_sunlight":"Plastificate e lavabili con un panno, reggono le mescolate di ogni giorno.","fact_moonlight_gold":"Foil arcobaleno dorato su cartoncino nero: un bellissimo secondo mazzo, quando ormai conosci le carte.","fact_moon_magic":"Carte con finitura effetto lino: opache, con una trama morbida al tatto.","fact_pink_moon":"Plastificate e lavabili con un panno, con accessori rosa coordinati.","fact_vintage_borderless":"L'arte originale del 1909, stampata senza bordi fino al taglio: il mazzo che consigliamo a chi inizia.","path_heading":"Sei alle prime armi con i tarocchi? Parti da qui:","path_book":"Leggi {book} gratis: le parti dalla 1 alla 4 del nostro corso, 91 pagine in tutto.","book_title":"La tua prima lettura","path_guidebook":"Leggi con la guida in PDF che ti inviamo via email con il mazzo.","price_with_code":"Il tuo prezzo con il codice del 20%: {price}. Lo applichiamo noi quando tocchi il pulsante qui sotto.","path_begin_vintage":"Comincia con il Borderless Vintage, il mazzo che consigliamo ai principianti.","see_cards_in_it":"Vedi le tue carte nel mazzo"},"ja":{"shown_in":"{deck}で表示しています。","change_deck":"デッキを変更","how_counted":"計算のしかた ↓","fit_heading_default":"このデッキで見るあなたのカード","fit_heading_picked":"このデッキがあなたに合う理由","fit_line_one":"あなたのカード「{card}」は、このデッキに入っています。手に取って、ご自分で並べてみることができます。","fit_line_many":"あなたのカード「{a}」と「{b}」は、このデッキに入っています。手に取って、ご自分で並べてみることができます。","list_sep":"、","fact_sunlight":"ラミネート加工で拭き取りができるので、毎日のシャッフルにも耐えます。","fact_moonlight_gold":"黒いカードに金色のレインボーフォイル。カードに親しんでから迎える、美しい2つ目のデッキです。","fact_moon_magic":"リネン調の仕上げのカード。マットで、手になじむやわらかな質感です。","fact_pink_moon":"ラミネート加工で拭き取りができ、おそろいのピンクのアクセサリー付きです。","fact_vintage_borderless":"1909年のオリジナルのアートを、縁なしでカードいっぱいに印刷。初心者の方におすすめしているデッキです。","path_heading":"タロットが初めてなら、まずはここから：","path_book":"「{book}」（英語版・91ページ）を無料でお読みいただけます。当店の入門コースの第1〜4部です。","book_title":"Your First Reading","path_guidebook":"デッキと一緒にメールでお届けするPDFガイドブックで読めます。","price_with_code":"20%オフコード適用後の価格：{price}。下のボタンをタップすると自動で適用されます。","path_begin_vintage":"初心者の方におすすめのデッキ、Borderless Vintage から始めましょう。","see_cards_in_it":"このデッキであなたのカードを見る"}};
  var T = STR[LC] || null;
  function t(k, vars) {
    var s = T && typeof T[k] === 'string' ? T[k] : '';
    if (vars) s = s.replace(/\{(\w+)\}/g, function (m, n) { return vars[n] !== undefined ? String(vars[n]) : m; });
    return s;
  }
  function factOf(id) { return t(/^learn-/.test(id) ? 'fact_learning_deck' : 'fact_' + String(id).replace(/-/g, '_')); }
  /* de/fr offer exactly one deck, their own learning deck: that is the beginner's deck there */
  var BEGINNER = (LC === 'de' || LC === 'fr') ? 'learn-' + LC : 'vintage-borderless';

  function offerable() {
    var list = DATA && DATA.decks, out = [];
    if (!list || !list.length) return out;
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].deck_id && list[i].available !== false) out.push(list[i]);
    }
    return out;
  }
  function deckInfo(id) {
    var list = offerable();
    for (var i = 0; i < list.length; i++) if (list[i].deck_id === id) return list[i];
    return null;
  }
  function deckLabel(id) {
    var d = deckInfo(id);
    return d ? (d.display_name || d.name || '') : '';
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }
  function scrollToEl(n) {
    if (!n) return;
    try { n.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { n.scrollIntoView(); }
  }

  function presetDeck(node) {
    try {
      if (node.getAttribute('deck') || offerable().length < 2) return;
      var mem = null;
      try { mem = JSON.parse(window.localStorage.getItem('df.rr.v1.birth') || 'null'); } catch (e) { mem = null; }
      if (mem && mem.deck && deckInfo(mem.deck)) { deckState.current = mem.deck; deckState.picked = true; return; }
      var best = deckInfo(BEGINNER) ? BEGINNER : (DATA && DATA.offer && DATA.offer.best_seller);
      if (!best || !deckInfo(best)) return;
      node.setAttribute('deck', best);
      deckState.current = best;
      deckState.preset = true;
    } catch (e) { warn('[rr] default deck not set', e && e.message); }
  }

  function markEmailForm() {
    try {
      var f = document.getElementById('bcc-email-form-tag');
      if (f && !f.hasAttribute('data-rr-birth-email')) f.setAttribute('data-rr-birth-email', '');
    } catch (e) { warn('[rr] email form not marked', e && e.message); }
  }

  function fitHeading() { return t(deckState.picked ? 'fit_heading_picked' : 'fit_heading_default'); }

  /* her pick, however it happened (tap, keyboard, the learning path's own link): the chip the engine
     marked is-on is the truth. The `deck` attribute follows it, or the next render would put her
     cards back in the default deck. */
  function syncPick(node) {
    var on = node.querySelector('.df-rr-chip--deck.is-on');
    var id = on && on.getAttribute('data-deck');
    if (!id || id === deckState.current) return;
    deckState.current = id;
    deckState.picked = true;
    if (node.getAttribute('deck')) node.setAttribute('deck', id);
    if (!T) return;
    Array.prototype.forEach.call(node.querySelectorAll('.rr-offer-fit__h'), function (h) { h.textContent = fitHeading(); });
    Array.prototype.forEach.call(node.querySelectorAll('.rr-shown-in__deck'), function (n) { n.parentNode.removeChild(n); });
  }

  function watchPicks(node) {
    function chipOf(e) { return e.target && e.target.closest ? e.target.closest('.df-rr-chip--deck') : null; }
    /* capture, so `picked` is set before the engine re-renders the offer for the new deck */
    node.addEventListener('click', function (e) {
      var c = chipOf(e);
      if (c && c.getAttribute('data-deck') !== deckState.current) deckState.picked = true;
      if (c) setTimeout(function () { syncPick(node); }, 0);
    }, true);
    node.addEventListener('keyup', function (e) { if (chipOf(e)) setTimeout(function () { syncPick(node); }, 0); }, true);
  }

  function tagReading(node) {
    var nums = [], names = [];
    Array.prototype.forEach.call(node.querySelectorAll('section.df-rr-birth__card[data-card-id]'), function (s) {
      var m = /^major-(\d{1,2})$/.exec(s.getAttribute('data-card-id') || '');
      if (!m) return;
      var n = parseInt(m[1], 10);
      nums.push(n);
      if (SLUGS[n]) names.push('birth-card-' + SLUGS[n]);
    });
    var out = node.querySelector('[data-birth-outcome]');
    var key = out && out.getAttribute('data-birth-outcome');
    if (!/^\d{1,2}(-\d{1,2}){0,2}$/.test(key || '')) key = nums.join('-');
    var y27 = year2027(node);
    Array.prototype.forEach.call(document.querySelectorAll('form'), function (f) {
      if (!f.querySelector('[data-rr-data-line]')) return;
      var input = f.querySelector('input[name="contact[tags]"]');
      if (!input) return;
      var base = input.getAttribute('data-rr-base');
      if (base === null) { base = input.value; input.setAttribute('data-rr-base', base); }
      input.value = key ? base + ',' + (IS_EN ? 'bcc-reading' : 'bcc-reading-' + LC) + ',bcc-key-' + key + (names.length ? ',' + names.join(',') : '') + (y27 ? ',bcc-y2027-' + y27 : '') : base;
    });
  }

  // Her 2027 year card number, counted by the engine's own yearCard() from the date she just typed;
  // null outside 5-17 or when the engine or the fields are missing. Only the number leaves the page.
  function year2027(node) {
    var eng = window.DF && window.DF.ReadingRoom && window.DF.ReadingRoom.engine;
    if (!eng || typeof eng.yearCard !== 'function') return null;
    var dEl = node._d || document.getElementById('rr-bd'), mEl = node._m || document.getElementById('rr-bm');
    var d = dEl ? parseInt(dEl.value, 10) : NaN, m = mEl ? parseInt(mEl.value, 10) : NaN;
    if (!(d >= 1 && d <= 31 && m >= 1 && m <= 12)) return null;
    var yc = null;
    try { yc = eng.yearCard(m, d, 2027); } catch (e) { return null; }
    var n = yc && yc.number;
    return (typeof n === 'number' && n >= 5 && n <= 17) ? n : null;
  }

  function shownIn(node, cardsRow, method) {
    var old = node.querySelector('.rr-shown-in');
    if (old) old.parentNode.removeChild(old);
    var p = el('p', 'rr-shown-in');
    if (deckState.preset && !deckState.picked && deckState.current) {
      var span = el('span', 'rr-shown-in__deck', t('shown_in', { deck: deckLabel(deckState.current) }) + ' ');
      var change = el('button', 'rr-linkbtn', t('change_deck'));
      change.type = 'button';
      change.addEventListener('click', function () {
        var picker = node.querySelector('[data-rr-deck-picker]') || node.querySelector('.df-rr-picker--decks');
        scrollToEl(picker);
        var chip = node.querySelector('.df-rr-chip--deck.is-on');
        if (chip) { try { chip.focus({ preventScroll: true }); } catch (e) {} }
      });
      span.appendChild(change);
      p.appendChild(span);
    }
    if (method) {
      var how = el('button', 'rr-linkbtn', t('how_counted'));
      how.type = 'button';
      how.addEventListener('click', function () { scrollToEl(method); });
      p.appendChild(how);
    }
    if (p.firstChild) cardsRow.parentNode.insertBefore(p, cardsRow.nextSibling);
  }

  function onReading(node) {
    var cardsRow = node.querySelector('.df-rr-birth__cards');
    if (!cardsRow) return;
    var out = cardsRow.parentNode;
    try { adoptBookOffer(node); } catch (e) {}
    try { openAsks(); } catch (e) {}
    var method = out.querySelector('.df-rr-birth__method');
    try {
      EMAIL = EMAIL || document.getElementById('bcc-email-section');
      var again = out.querySelector('.df-rr-birth__again');
      var outer = EMAIL && EMAIL.parentNode && EMAIL.parentNode.classList && EMAIL.parentNode.classList.contains('bcc-email-block') ? EMAIL.parentNode : null;
      [EMAIL, out.querySelector('.df-rr-learn'), method].forEach(function (n) {
        if (n) out.insertBefore(n, again && again.parentNode === out ? again : null);
      });
      if (EMAIL) EMAIL.classList.add('rr-in-reading');
      if (outer) outer.style.setProperty('--rr-min-h', '0px');
    } catch (e) { warn('[rr] result order not applied', e && e.message); }
    try { tagReading(node); } catch (e) { warn('[rr] reading tags not set', e && e.message); }
    if (T) { try { shownIn(node, cardsRow, method); } catch (e) { warn('[rr] shown-in line not added', e && e.message); } }
    try { langTag(); } catch (e) { warn('[rr] language tag not set', e && e.message); }
    if (IS_EN) { try { door(node, out); } catch (e) { warn('[rr] 2027 door not added', e && e.message); } }
    if (IS_EN) { try { deckJump(node, out, 0); } catch (e) { warn('[rr] deck line not added', e && e.message); } }
    try { onReturn(); } catch (e) { warn('[rr] return state not handled', e && e.message); }
  }

  /* run calculator-monetize-2026-11-03 r2: the deck offer sits ~5,600 px below the reading on a phone,
     so most readers never reach it. One line right under the pair offer (placed by rr-pair-buy.js on
     the same event, hence the short wait) names her cards and takes her to the deck. EN only. */
  function deckJump(node, out, tries) {
    var offer = out.querySelector('df-deck-offer');
    var pair = out.querySelector('#rr-pair');
    if (!offer || !pair || pair.parentNode !== out || pair.hidden) {
      if (tries < 12) setTimeout(function () { try { deckJump(node, out, tries + 1); } catch (e) {} }, 250);
      return;
    }
    var old = out.querySelector('.rr-deck-jump');
    if (old) old.parentNode.removeChild(old);
    var names = [];
    Array.prototype.forEach.call(node.querySelectorAll('section.df-rr-birth__card .df-rr-birth__card-name'), function (h) {
      var s = (h.textContent || '').trim();
      if (s) names.push(s);
    });
    var on = EXTRA && EXTRA.code_enabled === true;
    var who = names.length === 2 ? names[0] + ' and ' + names[1] : names.length === 1 ? names[0] : 'your cards';
    var p = el('p', 'rr-deck-jump', 'Rather hold ' + who + ' in your hands? They are in a real 78-card deck' + (on ? ', 20% off with your code. ' : '. '));
    var a = el('a', 'rr-deck-jump__link', 'See your deck \u2193');
    a.href = '#';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      try { offer.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (x) { offer.scrollIntoView(); }
    });
    p.appendChild(a);
    out.insertBefore(p, pair.nextSibling);
  }

  /* run calculator-monetize-2026-11-03: the offer photo is the product's own shot, which shows two cards
     that are not hers (Sunlight: The Empress and The Fool). Her cards, as the engine just drew them in
     THIS deck, replace it; the product shot stays when her cards are from another deck or missing. */
  function herCardsOnOffer(box, node, id, tries) {
    if (box.querySelector('.rr-offer-hers')) return;
    var out = node.querySelector('.df-rr-birth__out');
    var imgs = node.querySelectorAll('.df-rr-birth__cards img.df-rr-card__img');
    /* r2: with the best-seller preset (no deck tapped) the offer is built before the reading carries
       its deck and card images, so the check is retried for up to 3 s instead of giving up at once */
    if (!out || !id || out.getAttribute('data-deck') !== id || !imgs.length) {
      tries = (tries || 0) + 1;
      if (tries < 13 && box.isConnected !== false) setTimeout(function () {
        try { herCardsOnOffer(box, node, id, tries); } catch (e) { warn('[rr] her cards not shown on the offer', e && e.message); }
      }, 250);
      return;
    }
    var row = el('div', 'rr-offer-hers');
    Array.prototype.forEach.call(imgs, function (im, i) {
      if (i > 2) return;
      var c = im.cloneNode(false);
      c.removeAttribute('id');
      c.className = 'rr-offer-hers__img';
      c.setAttribute('loading', 'eager');
      row.appendChild(c);
    });
    var photo = box.querySelector('.df-rr-offer__photo');
    if (photo) { box.insertBefore(row, photo); photo.hidden = true; }
    else {
      var h = box.querySelector('.df-rr-offer__title');
      if (!h) return;
      box.insertBefore(row, h.nextSibling);
    }
  }

  /* the offer box, EN, on the birth tool only: one fit line naming HER cards, one true fact about the
     deck, then the learning path. Card names are read as text from the reading the engine rendered. */
  function fitOffer(box) {
    if (!T || !box.closest || !box.closest('df-birth-cards') || box.querySelector('.rr-offer-fit')) return;
    var node = box.closest('df-birth-cards');
    var id = box.getAttribute('data-deck') || '';
    try { herCardsOnOffer(box, node, id); } catch (e) { warn('[rr] her cards not shown on the offer', e && e.message); }
    var names = [];
    Array.prototype.forEach.call(node.querySelectorAll('section.df-rr-birth__card .df-rr-birth__card-name'), function (h) {
      var t = (h.textContent || '').trim();
      if (t) names.push(t);
    });
    var fit = el('div', 'rr-offer-fit');
    fit.appendChild(el('p', 'rr-offer-fit__h', fitHeading()));
    if (names.length === 1) fit.appendChild(el('p', 'rr-offer-fit__line', t('fit_line_one', { card: names[0] })));
    else if (names.length > 1) fit.appendChild(el('p', 'rr-offer-fit__line', t('fit_line_many', { a: names.slice(0, -1).join(t('list_sep') || ', '), b: names[names.length - 1] })));
    var fact = factOf(id);
    if (fact) fit.appendChild(el('p', 'rr-offer-fit__line', fact));
    if (fit.childNodes.length < 2) return;
    var anchor = box.querySelector('.df-rr-offer__variant') || box.querySelector('.df-rr-offer__price');
    if (anchor) anchor.parentNode.insertBefore(fit, anchor.nextSibling);
    else return;

    var path = el('div', 'rr-offer-path');
    path.appendChild(el('p', 'rr-offer-path__h', t('path_heading')));
    var ol = el('ol', 'rr-offer-path__list');
    var book = BOOK && BOOK.querySelector('a[data-rr-book-dl]');
    if (book) {
      var li1 = el('li');
      var bk = t('path_book').split('{book}');
      if (bk[0]) li1.appendChild(document.createTextNode(bk[0]));
      var a = el('a', null, t('book_title'));
      ['href', 'target', 'rel', 'download', 'data-rr-book-dl', 'data-lang', 'data-paper', 'data-file'].forEach(function (k) {
        if (book.hasAttribute(k)) a.setAttribute(k, book.getAttribute(k));
      });
      li1.appendChild(a);
      if (bk.length > 1 && bk[1]) li1.appendChild(document.createTextNode(bk[1]));
      ol.appendChild(li1);
    }
    var li2 = el('li');
    if (id === BEGINNER) {
      li2.textContent = t('path_guidebook');
    } else {
      var chipSel = '.df-rr-chip--deck[data-deck="' + BEGINNER + '"]';
      li2.appendChild(document.createTextNode(t('path_begin_vintage') + ' '));
      if (node.querySelector(chipSel)) {
        var see = el('button', 'rr-linkbtn', t('see_cards_in_it'));
        see.type = 'button';
        see.addEventListener('click', function () {
          var chip = node.querySelector(chipSel);
          if (!chip) return;
          chip.click();
          scrollToEl(node.querySelector('.df-rr-birth__cards'));
        });
        li2.appendChild(see);
      }
    }
    ol.appendChild(li2);
    path.appendChild(ol);
    box.appendChild(path);
  }

  /* ------------------------------------- 8b · run calculator-conversion-followup-2026-10-23 (hub brief)
       a. offerName (item 4). The engine names the offer with deck.display_name, which for the DE/FR learning
          decks is a fragment built for a sentence ("deutschen Lerndeck"). The offer's name line and photo alt
          show the product's own nominative name instead -- only when display_name starts lower-case, i.e. is
          such a fragment; a real short name ("Sunlight Tarot") is left alone.
       b. langTag (item 6). A non-EN calculator signup is tagged bcc-reading-<lc>, never the EN bcc-reading.
       c. THE 2027 DOOR (item 2, EN only, a 14-day demand test the hub measures). Under the free reading,
          above the deck offer: "Your 2027 spread", planned price 9.99 in her own currency (USD/GBP/EUR/AUD/
          CAD/CHF only; no price line anywhere else), one email field. No money is taken and no product
          exists: the field submits the page's own calculator form (Shopify's CAPTCHA refuses a scripted
          POST), so she gets exactly the calculator signup -- same consent text, cloned from that form, same
          tags -- plus `bcc-y2027-door`. Events door_view (50 % visible, once per page view), door_click
          (first focus or tap), door_submit (just before the form goes), door_signup (the page came back
          with Shopify's success node). Every door signup also counts as bcc_email_submit/email_submit:
          the hub subtracts door_submit.
       d. onReturn (item 7). After the form posts back the page reloads at the top while the engine rebuilds
          the reading, so on a phone she never sees that it worked. The confirmation -- the door's own, or
          the form's "You're in." -- is scrolled into view once, unless she has already touched the page.
       e. reopenFromUrl (item 8). ?d=YYYYMMDD (or ?d=MMDD) on the calculator URL fills the date and shows
          her reading. The parameter is removed from the address bar at once (a date of birth must not stay
          in history or in a copied link). MMDD has no year: the reading is shown only when this tab still
          remembers the year for that day and month, else the year field gets focus. */
  function offerName(box) {
    var d = deckInfo(box.getAttribute('data-deck') || '');
    if (!d || !d.name || !d.display_name || d.name === d.display_name) return;
    var c = d.display_name.charAt(0);
    if (c === c.toUpperCase()) return;
    var n = box.querySelector('.df-rr-offer__name');
    if (n && (n.textContent || '').trim() === d.display_name) n.textContent = d.name;
    var img = box.querySelector('img.df-rr-offer__photo');
    if (img && img.getAttribute('alt') === d.display_name) img.setAttribute('alt', d.name);
  }

  function langTag() {
    if (IS_EN || !/^[a-z]{2}$/.test(LC)) return;
    var tag = 'bcc-reading-' + LC;
    ['bcc-email-form-tag', 'bcc-compact-email-form-tag'].forEach(function (fid) {
      var f = document.getElementById(fid);
      var input = f && f.querySelector('input[name="contact[tags]"]');
      if (!input || (',' + input.value + ',').indexOf(',' + tag + ',') !== -1) return;
      input.value = input.value ? input.value + ',' + tag : tag;
    });
  }

  var DOOR = { key: 'df.rr.door.y2027', seen: false, clicked: false, submitted: false, signed: false, yc: null, io: null };
  var DOOR_CUR = { USD: 1, GBP: 1, EUR: 1, AUD: 1, CAD: 1, CHF: 1 };
  var DOOR_OK = "You're on the list. Nothing to confirm: we'll write to you first when the 2027 spread opens.";
  var DOOR_ERR = "Your email didn't go through. Please check it and try again.";
  function doorCurrency() {
    try {
      var c = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      return typeof c === 'string' ? c.toUpperCase() : '';
    } catch (e) { return ''; }
  }
  function doorPrice() {
    var c = doorCurrency();
    if (!DOOR_CUR[c] || typeof Intl === 'undefined' || typeof Intl.NumberFormat !== 'function') return '';
    try {
      var s = new Intl.NumberFormat('en', { style: 'currency', currency: c }).format(9.99);
      return s.indexOf(c) === -1 ? s + ' ' + c : s;
    } catch (e) { return ''; }
  }
  function postedBack() {
    var m = /(?:^|[?&])customer_posted=([^&]*)/.exec(window.location.search || '');
    return !!m && (m[1] === '' || m[1] === 'true' || m[1] === '1');
  }
  function doorSend(name, extra) {
    var p = {
      door: 'y2027', door_v: 1, price: doorPrice() ? 9.99 : null, currency: doorCurrency(), price_shown: !!doorPrice(),
      year_card: DOOR.yc, post_return: false, page_locale: (document.documentElement.lang || '').slice(0, 2)
    };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) { warn('[rr] gtag ' + name + ' failed', e && e.message); }
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: name };
      for (var j in p) if (Object.prototype.hasOwnProperty.call(p, j)) o[j] = p[j];
      window.dataLayer.push(o);
    } catch (e) { warn('[rr] dataLayer ' + name + ' failed', e && e.message); }
    try { if (window.trekkie && typeof window.trekkie.track === 'function') window.trekkie.track(name, p); } catch (e) { warn('[rr] trekkie ' + name + ' failed', e && e.message); }
  }
  function doorFlag() {
    try {
      var f = JSON.parse(window.sessionStorage.getItem(DOOR.key) || 'null');
      return f && typeof f.t === 'number' && Date.now() - f.t < 30 * 60 * 1000 ? f : null;
    } catch (e) { return null; }
  }
  function doorDone() { try { return window.sessionStorage.getItem(DOOR.key + '.done') === '1'; } catch (e) { return false; } }
  function cardTitle(slug) {
    return String(slug || '').split('-').map(function (w, i) {
      return i > 0 && (w === 'of' || w === 'the') ? w : w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }
  function doorConfirm(box) {
    Array.prototype.forEach.call(box.querySelectorAll('.rr-door__form, .rr-door__note'), function (n) { n.parentNode.removeChild(n); });
    var m = box.querySelector('.rr-door__msg');
    if (m) { m.textContent = DOOR_OK; m.className = 'rr-door__msg rr-door__msg--ok'; }
  }
  function doorWatch(box) {
    if (DOOR.seen || typeof window.IntersectionObserver !== 'function') return;
    if (DOOR.io) DOOR.io.disconnect();
    DOOR.io = new window.IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        if (!DOOR.seen && ents[i].isIntersecting && ents[i].intersectionRatio >= 0.5) {
          DOOR.seen = true;
          DOOR.io.disconnect();
          doorSend('door_view', { post_return: postedBack() });
        }
      }
    }, { threshold: [0.5] });
    DOOR.io.observe(box);
  }
  function door(node, out) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-df-door]'), function (n) { n.parentNode.removeChild(n); });
    var nat = document.getElementById('bcc-email-form-tag');
    if (!nat || !nat.querySelector('input[name="contact[email]"]')) return;
    var anchor = out.querySelector('.df-rr-handoff') || out.querySelector('df-deck-offer') || (EMAIL && EMAIL.parentNode === out ? EMAIL : null);
    if (!anchor) return;
    DOOR.yc = year2027(node);
    var price = doorPrice();
    var box = el('section', 'rr-door');
    box.setAttribute('data-df-door', 'y2027');
    box.setAttribute('aria-labelledby', 'rr-door-title');
    box.appendChild(el('p', 'rr-door__eyebrow', 'Opening soon'));
    var h = el('h3', 'rr-door__title', 'Your 2027 spread');
    h.id = 'rr-door-title';
    box.appendChild(h);
    box.appendChild(el('p', 'rr-door__body', 'A personal reading for the year ahead, built from your birth cards, your 2027 year card' +
      (DOOR.yc && SLUGS[DOOR.yc] ? ' (' + cardTitle(SLUGS[DOOR.yc]) + ')' : '') + ' and four cards you draw for one question you choose.'));
    if (price) box.appendChild(el('p', 'rr-door__price', 'Planned price: ' + price + '. No payment now.'));
    var form = el('form', 'rr-door__form');
    var lab = el('label', 'rr-door__label', 'Your email');
    lab.setAttribute('for', 'rr-door-email');
    var inp = document.createElement('input');
    inp.type = 'email';
    inp.id = 'rr-door-email';
    inp.className = 'bcc-email-input rr-door__input';
    inp.setAttribute('autocomplete', 'email');
    inp.required = true;
    inp.setAttribute('aria-required', 'true');
    var btn = el('button', 'bcc-email-btn rr-door__btn', 'Send it to me first');
    btn.type = 'submit';
    var row = el('div', 'rr-door__row');
    row.appendChild(inp);
    row.appendChild(btn);
    form.appendChild(lab);
    form.appendChild(row);
    box.appendChild(form);
    box.appendChild(el('p', 'rr-door__note', (price ? '' : 'No payment now. ') + "We'll write to you first when it opens. Sending your email also adds you to the 2027 spread list."));
    /* the calculator form's own consent lines, word for word, privacy link included */
    Array.prototype.forEach.call(nat.querySelectorAll('.bcc-email-formwrap .bcc-email-note'), function (p) {
      var c = p.cloneNode(true);
      c.removeAttribute('data-rr-data-line');
      c.removeAttribute('id');
      c.className = 'bcc-email-note rr-door__note';
      box.appendChild(c);
    });
    var msg = el('p', 'rr-door__msg');
    msg.setAttribute('aria-live', 'polite');
    box.appendChild(msg);
    function clickOnce() { if (!DOOR.clicked) { DOOR.clicked = true; doorSend('door_click'); } }
    /* Shopify binds its spam check to the native form on that form's own focusin; this field sits
       outside it, so arm the native form here or its submit is swallowed unbound */
    function arm() { try { if (!nat.dataset.hcaptchaBound) nat.dispatchEvent(new Event('focusin', { bubbles: true })); } catch (x) {} }
    inp.addEventListener('focus', arm);
    btn.addEventListener('pointerdown', arm);
    inp.addEventListener('focus', clickOnce);
    btn.addEventListener('pointerdown', clickOnce);
    btn.addEventListener('click', clickOnce);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clickOnce();
      if (typeof inp.checkValidity === 'function' && !inp.checkValidity()) { try { inp.reportValidity(); } catch (x) {} return; }
      var email = nat.querySelector('input[name="contact[email]"]');
      var tags = nat.querySelector('input[name="contact[tags]"]');
      email.value = (inp.value || '').trim();
      if (tags && (',' + tags.value + ',').indexOf(',bcc-y2027-door,') === -1) tags.value = tags.value + ',bcc-y2027-door';
      try { window.sessionStorage.setItem(DOOR.key, JSON.stringify({ t: Date.now() })); } catch (x) {}
      if (!DOOR.submitted) { DOOR.submitted = true; doorSend('door_submit'); }
      btn.disabled = true;
      setTimeout(function () { btn.disabled = false; }, 8000);
      arm();
      var waited = 0;
      (function go() {
        if (!nat.dataset.hcaptchaBound && waited++ < 40) { setTimeout(go, 150); return; }
        try {
          if (typeof nat.requestSubmit === 'function') nat.requestSubmit();
          else { var nb = document.getElementById('bcc-email-btn'); if (nb) nb.click(); }
        } catch (x) { btn.disabled = false; warn('[rr] 2027 door submit failed', x && x.message); }
      })();
    });
    if (doorDone()) doorConfirm(box);
    anchor.parentNode.insertBefore(box, anchor);
    doorWatch(box);
  }

  var RETURN_DONE = false;
  function scrollSoon(n) {
    if (!n || !n.scrollIntoView) return;
    var moved = false;
    function stop() { moved = true; }
    ['touchstart', 'wheel', 'keydown'].forEach(function (tp) { window.addEventListener(tp, stop, { once: true, passive: true }); });
    var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    raf(function () { raf(function () { setTimeout(function () {
      if (moved) return;
      try { n.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { n.scrollIntoView(); }
    }, 120); }); });
  }
  function onReturn() {
    if (RETURN_DONE || !postedBack()) return;
    var nat = document.getElementById('bcc-email-form-tag');
    if (!nat) return;
    var ok = nat.querySelector('.bcc-email-ok[role="status"]');
    var err = nat.querySelector('.bcc-email-err');
    if (!ok && !err) return;
    RETURN_DONE = true;
    var box = document.querySelector('[data-df-door="y2027"]');
    var target = ok || err;
    if (doorFlag()) {
      try { window.sessionStorage.removeItem(DOOR.key); } catch (e) {}
      if (ok) {
        try { window.sessionStorage.setItem(DOOR.key + '.done', '1'); } catch (e) {}
        if (!DOOR.signed) { DOOR.signed = true; doorSend('door_signup', { post_return: true }); }
        if (box) { doorConfirm(box); target = box; }
      } else if (box) {
        var m = box.querySelector('.rr-door__msg');
        if (m) { m.textContent = DOOR_ERR; m.className = 'rr-door__msg rr-door__msg--err'; }
        target = box;
      }
    }
    scrollSoon(target);
  }

  function reopenFromUrl(node) {
    if (postedBack()) return;
    var m = /(?:^|[?&])d=(\d{4}|\d{8})(?=&|$)/.exec(window.location.search || '');
    if (!m) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('d');
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
    var s = m[1], y = null, mo, d;
    if (s.length === 8) { y = +s.slice(0, 4); mo = +s.slice(4, 6); d = +s.slice(6, 8); } else { mo = +s.slice(0, 2); d = +s.slice(2, 4); }
    var now = new Date().getFullYear();
    var probe = new Date(Date.UTC(y || 2000, mo - 1, d));
    if (probe.getUTCMonth() !== mo - 1 || probe.getUTCDate() !== d || (y !== null && (y < 1900 || y > now))) return;
    if (y === null) {
      try {
        var mem = JSON.parse(window.sessionStorage.getItem('df.rr.s1.birth') || 'null');
        if (mem && +mem.m === mo && +mem.d === d && +mem.y >= 1900 && +mem.y <= now) y = +mem.y;
      } catch (e) {}
    }
    var tries = 0;
    var iv = setInterval(function () {
      var bd = document.getElementById('rr-bd'), bm = document.getElementById('rr-bm'), by = document.getElementById('rr-by');
      var go = node.querySelector('[data-rr-birth-go]');
      if (!(bd && bm && by && go && node.getAttribute('data-df-ready'))) { if (++tries > 80) clearInterval(iv); return; }
      clearInterval(iv);
      function put(i, v) {
        i.value = String(v);
        i.dispatchEvent(new Event('input', { bubbles: true }));
        i.dispatchEvent(new Event('change', { bubbles: true }));
      }
      put(bd, d);
      put(bm, mo);
      if (y === null) { try { by.focus(); } catch (e) {} return; }
      put(by, y);
      go.click();
    }, 150);
  }

  function journeyCss() {
    if (document.getElementById('rr-journey-css')) return;
    var s = document.createElement('style');
    s.id = 'rr-journey-css';
    s.textContent =
      '.rr-shown-in{font-size:14px;color:var(--rr-brown,#8B6F5A);text-align:center;margin:8px 0 16px}' +
      '.rr-shown-in__deck{margin-right:12px}' +
      '.rr-linkbtn{background:none;border:0;padding:4px 2px;min-height:32px;font:inherit;color:var(--rr-copper,#B3785D);text-decoration:underline;cursor:pointer}' +
      '.rr-offer-fit{margin:12px 0 16px;text-align:left}' +
      '.rr-offer-hers{display:flex;justify-content:center;gap:12px;margin:12px 0 10px}' +
      '.rr .rr-deck-jump{margin:4px 0 22px;padding:12px 14px;border:1px solid rgba(44,34,24,.18);border-radius:10px;font-size:15px;line-height:1.45}' +
      '.rr .rr-deck-jump__link{font-weight:700;text-decoration:underline;white-space:nowrap}' +
      '.rr-offer-hers__img{width:38%;max-width:160px;height:auto;border-radius:8px;box-shadow:0 2px 10px rgba(44,34,24,.18)}' +
      '.df-rr-offer__photo[hidden]{display:none!important}' +
      '.rr .rr-offer-xmas{margin:8px 0 0;font-size:14px;font-weight:600;color:var(--rr-ink,#2c2218)}' +
      '.rr .rr-offer-price-code{margin:10px 0 8px;font-size:15px;font-weight:600}' +
      '.rr .rr-offer-fit__h{font-family:var(--rr-serif)!important;font-weight:600;font-size:17px;margin:0 0 6px}' +
      '.rr .rr-offer-fit__line{font-size:15px;line-height:1.5;margin:0 0 6px}' +
      '.rr-offer-path{margin:20px 0 0;padding:16px 0 0;border-top:1px solid var(--rr-rule,#E4DBCE);text-align:left}' +
      '.rr .rr-offer-path__h{font-weight:600;font-size:15px;margin:0 0 8px}' +
      '.rr-offer-path__list{margin:0;padding:0 0 0 22px;list-style:decimal outside;font-size:15px;line-height:1.5}' +
      '.rr-offer-path__list li{margin:0 0 8px;list-style:inherit;display:list-item}' +
      '.rr-offer-path__list a{color:var(--rr-copper,#B3785D);font-weight:600}' +
      '#bcc-email-section.rr-in-reading{margin:24px 0}' +
      '#bcc-email-section.rr-in-reading,#bcc-email-section.rr-in-reading *{box-sizing:border-box}' +
      '#bcc-email-section.rr-in-reading form,#bcc-email-section.rr-in-reading div{margin:0}' +
      '.rr #bcc-email-section.rr-in-reading .bcc-email-title{margin:0 0 16px}' +
      '.rr #bcc-email-section.rr-in-reading .bcc-email-note,.rr #bcc-email-section.rr-in-reading .bcc-email-msg{margin:12px 0 0}' +
      '.rr-door,.rr-door *{box-sizing:border-box}' +
      '.rr-door{margin:24px 0;padding:20px 16px;border:1px solid var(--rr-rule,#E4DBCE);border-radius:12px;background:#FAF7F2;text-align:left}' +
      '.rr .rr-door__eyebrow{font-size:13px;letter-spacing:.08em;text-transform:uppercase;font-weight:600;color:var(--rr-copper,#B3785D);margin:0 0 6px}' +
      '.rr .rr-door__title{font-family:var(--rr-serif)!important;font-size:22px;line-height:1.25;margin:0 0 8px}' +
      '.rr .rr-door__body{font-size:15px;line-height:1.5;margin:0 0 8px}' +
      '.rr .rr-door__price{font-size:15px;font-weight:600;margin:0 0 12px}' +
      '.rr-door__label{display:block;font-size:14px;font-weight:600;margin:0 0 6px}' +
      '.rr-door__row{display:flex;flex-wrap:wrap;gap:8px}' +
      '.rr-door__input{flex:1 1 200px;min-width:0;font-size:16px!important}' +
      '.rr-door__btn{flex:0 0 auto}' +
      '@media (max-width:480px){.rr-door__btn{flex:1 1 100%}}' +
      '.rr .rr-door__note{font-size:13px;line-height:1.5;margin:10px 0 0;color:#736862}' +
      '.rr-door__note a{color:inherit;text-decoration:underline}' +
      '.rr .rr-door__msg{font-size:15px;line-height:1.5;margin:10px 0 0}' +
      '.rr .rr-door__msg:empty{display:none}' +
      '.rr-door__msg--ok{color:var(--rr-brown,#8B6F5A);font-weight:600}' +
      '.rr-door__msg--err{color:#9b2c2c;font-weight:600}';
    (document.head || document.documentElement).appendChild(s);
  }

  function adoptPicker(node) {
    try {
      var slot = node.querySelector('[data-rr-deck-picker]');
      var wrap = node.querySelector('.df-rr-birth__pickerwrap');
      if (!slot || !wrap || wrap.parentNode === slot) return;
      slot.appendChild(wrap);
    } catch (e) { warn('[rr] picker slot not adopted', e && e.message); }
  }

  /* --------------------------------------------------------------------------- mounting */
  function mountOne(node, extraOpts) {
    var DF = window.DF && window.DF.ReadingRoom;
    if (!DF || typeof DF.mount !== 'function') return false;
    if (node.getAttribute('data-df-mounted')) return true;
    node.setAttribute('data-df-mounted', '1');
    node.addEventListener('df-ready', function () { ready(node); });
    var opts = extraOpts ? { deck: extraOpts.deck } : {};
    if (DATA) opts.data = DATA;
    var qsel = node.getAttribute('question-el');
    if (qsel) {
      var qEl = resolveQuestionEl(qsel);
      if (qEl) opts.questionEl = qEl;
    }
    try {
      var inst = DF.mount(node, opts);
      if (inst) ready(node);
      return true;
    } catch (e) {
      /* R-F0: leave the server-rendered content in place rather than a broken tool */
      node.removeAttribute('data-df-mounted');
      warn('[rr] mount failed', node.tagName, e && e.message);
      return false;
    }
  }

  function boot() {
    var DF = window.DF && window.DF.ReadingRoom;
    if (!DF || typeof DF.mount !== 'function') return false;
    var nodes = document.querySelectorAll(SEL);
    if (!nodes.length) return true;
    Array.prototype.forEach.call(nodes, function (node) {
      var isBirth = node.tagName && node.tagName.toLowerCase() === 'df-birth-cards';
      /* 2026-10-23, hub brief calculator-journey-fix item 3, which replaces the owner's 02.10 order
         (date, then deck, then show): with no deck chosen, "Show my cards" shows her cards in the
         best-seller, and the engine's picker stays in place so one tap switches. presetDeck() sets
         the `deck` attribute only when she has no remembered deck of her own (section 8a); the
         `deck` OPTION stays unused, as before. markEmailForm() must run before mount: the engine
         looks for its e-mail form once, at its first render. */
      if (isBirth) { presetDeck(node); markEmailForm(); journeyCss(); }
      mountOne(node, null);
      if (isBirth) {
        watchPicks(node);
        node.addEventListener('df-reading', function () { onReading(node); });
        try { reopenFromUrl(node); } catch (e) { warn('[rr] ?d reopen failed', e && e.message); }
        if (postedBack()) setTimeout(function () { try { onReturn(); } catch (e) { warn('[rr] return state not handled', e && e.message); } }, 2500);
        adoptPicker(node);
        node.addEventListener('df-ready', function () { adoptPicker(node); });
        node.addEventListener('reveal', openAsks);
        node.addEventListener('reveal', function () { adoptEmailCompact(node); });
        node.addEventListener('reveal', function () { adoptBookOffer(node); });
      }
    });
    return true;
  }

  /* Warm the deferred deck-image map. Only the default deck's images ship inline (C6), so the first
     reveal on ANY other deck waits on the engine's own fetch of rr-deck-images.json — and the owner's
     flow is to pick a deck first, which makes that the common case, not the edge one. One idle fetch
     puts it in the HTTP cache before she can possibly have typed a date. It is a static same-origin
     asset with no user data in it, so it costs nothing and tells no one anything. */
  function warmDeckImages() {
    var u = DATA && typeof DATA.deck_images_url === 'string' ? DATA.deck_images_url : null;
    if (!u || u.charAt(0) !== '/' || u.charAt(1) === '/' || typeof fetch !== 'function') return;
    var go = function () { fetch(u, { credentials: 'omit' }).catch(function () {}); };
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(go, { timeout: 2000 });
    else setTimeout(go, 400);
  }

  /* ------------------------------------------- 6b · the two strings the deck block is given
     The engine takes its handoff sentence from `strings.deck_handoff` and its buy-button label from
     `strings.add_to_cart`, and both of those belong to the business rather than to the engine, so
     they are set on the data object before mount through the engine's own public mount(el, { data })
     signature. Nothing is patched into engine DOM afterwards.

       deck_handoff — dark-marketing's `deck_reason_line`, verbatim, placeholders intact. With the
         section's code switch OFF it becomes the same sentence without the discount clause, because
         a code printed before the Shopify discount exists is a promise that fails at her checkout.
       add_to_cart — the brief's `deck_cta`, "Shop This Deck". dark-marketing's own field is
         `deck_reason_cta_label: "Save 15%"`, which is carried in the data block as
         `marketing_cta_alternative` so the choice between them is a visible decision, not a silent
         one. "Save 15%" cannot go on a button until the discount is real. */
  function applyDeckBlockCopy() {
    if (!DATA || !DATA.strings || typeof DATA.strings !== 'object') return;
    var on = EXTRA && EXTRA.code_enabled === true;
    /* 2026-10-03 · WITH THE CODE ON, THE PAGE'S OWN SENTENCE WINS, hub's ruling. This file used to
       overwrite `deck_handoff` with one hard-coded English line on every locale, so five languages
       read an English sentence directly above the buy button. dark-dev now ship that same sentence —
       it is dark-marketing's accepted `deck_reason_line` — translated in all six, so the override is
       not needed to get the right words any more, only to get the right SWITCH. English is unchanged:
       the payload's English value is byte-identical to the string this file used to impose.
       With the code OFF the override stays, because the payload's line carries a {code} placeholder
       and a code printed before the Shopify discount exists is a promise that fails at her checkout.
       That fallback is still English-only and is reported as such. */
    if (on) {
      var own = DATA.strings.deck_handoff;
      /* 2026-10-09, hub return: a single-offerable-deck market (de/fr learning decks today) never
         showed a picker, so dark-marketing's accepted "the deck you chose" phrasing is false there
         specifically -- swap in the locale's no-choice variant whenever exactly one deck is offered,
         ahead of the own-string/English-fallback logic below (which stays correct for every other
         case: two-or-more decks, or a locale with no single-deck override at all). */
      var singleDeck = Array.isArray(DATA.decks) && DATA.decks.length === 1;
      var singleOverride = singleDeck && EXTRA && typeof EXTRA.deck_handoff_code_single === 'string' && EXTRA.deck_handoff_code_single ? EXTRA.deck_handoff_code_single : null;
      if (singleOverride) {
        DATA.strings.deck_handoff = singleOverride;
      } else if (!(typeof own === 'string' && own.indexOf('{deck}') !== -1 && own.indexOf('{code}') !== -1)) {
        var en = EXTRA && typeof EXTRA.deck_handoff_code === 'string' ? EXTRA.deck_handoff_code : null;
        if (en) DATA.strings.deck_handoff = en;
      }
    } else {
      var plain = EXTRA && typeof EXTRA.deck_handoff_plain === 'string' ? EXTRA.deck_handoff_plain : null;
      if (plain) DATA.strings.deck_handoff = plain;
      /* 2026-10-08, hub return round 2: `.df-rr-strip` is a SEPARATE sentence from `deck_handoff`,
         read via bs('strip_line') -> DATA.strings.birth.strip_line, sourced from
         assets/rr-birth-defer-<lang>.json. Same off-switch, same single flip point. */
      var stripPlain = EXTRA && typeof EXTRA.strip_line_plain === 'string' ? EXTRA.strip_line_plain : null;
      if (stripPlain) {
        if (!DATA.strings.birth || typeof DATA.strings.birth !== 'object') DATA.strings.birth = {};
        DATA.strings.birth.strip_line = stripPlain;
      }
    }
    if (EXTRA && typeof EXTRA.deck_cta === 'string' && EXTRA.deck_cta) DATA.strings.add_to_cart = EXTRA.deck_cta;
    /* r2 (calculator-monetize-2026-11-03): with her code on, the English button says what the tap does */
    if (on && DATA.lang === 'en') DATA.strings.add_to_cart = 'Get my deck \u00b7 20% off';
    /* the engine's picker label, from the label file this theme has carried translated all along */
    if (EXTRA && typeof EXTRA.pick_deck === 'string' && EXTRA.pick_deck) DATA.strings.pick_deck = EXTRA.pick_deck;
  }

  /* The hint under the disabled button. Liquid renders the picker's own label into it so that a
     locale with no sentence of its own still says something true; where a sentence exists it
     replaces it, because "Pick a deck" was already on screen as the picker's label and printing it
     twice reads as a bug. Text only — nothing here is built from anything she typed. */
  function pickFirstHint() {
    var p = document.querySelector('.rr-pick-first');
    if (!p) return;
    var t = EXTRA && typeof EXTRA.pick_first === 'string' ? EXTRA.pick_first : '';
    if (t) p.textContent = t;
  }

  /* ---------------------------------------------- 7 - counting the free-book downloads (2026-10-09)
     One GA4 event per tap on the free-book download link -- same multi-fallback pattern as the
     course-books page's `course_book_download`: gtag (the GA4 the theme already loads) first,
     dataLayer and Shopify's own trekkie as fallbacks. Delegated on `document` because the link is
     inserted after reveal, not present at boot; bound on `pointerdown` as well as `click` because
     the link opens a new tab and a plain click handler can be cut short by the navigation. A
     seen-map keeps one event per button per page view. */
  function trackBookDownload() {
    var seen = Object.create(null);
    function send(a) {
      var key = a.getAttribute('data-file') || a.href;
      if (seen[key]) return;
      seen[key] = true;
      var bookLanguage = a.getAttribute('data-lang') || '';
      var paper = a.getAttribute('data-paper') || '';
      var fileKey = a.getAttribute('data-file') || '';
      var pageLocale = (document.documentElement.lang || '').slice(0, 2);
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'free_book_download', { book_language: bookLanguage, paper: paper, file_key: fileKey, page_locale: pageLocale });
        }
      } catch (e) { warn('[rr] gtag free_book_download failed', e && e.message); }
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'free_book_download', book_language: bookLanguage, paper: paper, file_key: fileKey, page_locale: pageLocale });
      } catch (e) { warn('[rr] dataLayer free_book_download failed', e && e.message); }
      try {
        if (window.trekkie && typeof window.trekkie.track === 'function') {
          window.trekkie.track('free_book_download', { book_language: bookLanguage, paper: paper, file_key: fileKey, page_locale: pageLocale });
        }
      } catch (e) { warn('[rr] trekkie free_book_download failed', e && e.message); }
    }
    function onEvent(e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-rr-book-dl]') : null;
      if (a) send(a);
    }
    document.addEventListener('click', onEvent, true);
    document.addEventListener('pointerdown', onEvent, true);
  }

  function start() {
    applyDeckBlockCopy();
    pickFirstHint();
    watchOffers(document);
    warmDeckImages();
    trackBookDownload();
    /* The birth page waits for the deferred strings; every other page boots immediately, because
       nothing on it is deferred. A failed fetch still resolves, so the tool always mounts. */
    if (DATA && DATA.strings_defer_url) {
      deferredReady.then(function () {
        /* the deferred file's own mergeDeferred() just overwrote DATA.strings.birth key-by-key,
           which would silently restore the code-promising strip_line this file switched off above
           (applyDeckBlockCopy ran before this merge existed) -- reapply it, idempotent either way. */
        applyDeckBlockCopy();
        if (!boot()) {
          var tries = 0;
          var t = setInterval(function () { if (boot() || ++tries > 60) clearInterval(t); }, 100);
        }
      });
      return;
    }
    if (!boot()) {
      var tries = 0;
      var t = setInterval(function () { if (boot() || ++tries > 60) clearInterval(t); }, 100);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
